import styled, { keyframes } from "styled-components";

const blink = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

const SkeletonBox = styled.div<{ first?: boolean }>`
  width: 100%;
  margin-bottom: 4rem;
  border-radius: 0px;
  background-color: #1a1a1a;
  overflow: hidden;
  margin-top: ${({ first }) => (first ? "2rem" : "0")};
`;

const SkeletonHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
`;

const Avatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #2a2a2a;
  animation: ${blink} 1.5s ease-in-out infinite;
  background: #2a2a2a;
  background-size: 1000px 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
`;

const NameBlock = styled.div`
  flex: 1;
  height: 14px;
  border-radius: 4px;
  background: #2a2a2a;
  animation: ${blink} 1.5s ease-in-out infinite;
  background: #2a2a2a;

  background-size: 1000px 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
`;

const ImagePlaceholder = styled.div`
  height: 600px;
  background-color: #2a2a2a;
  animation: ${blink} 1.5s ease-in-out infinite;
  background: #2a2a2a;

  background-size: 1000px 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
`;

const Description = styled.div`
  height: 20px;
  margin: 1rem;
  border-radius: 4px;
  background: #2a2a2a;
  animation: ${blink} 1.5s ease-in-out infinite;
  background: #2a2a2a;

  background-size: 1000px 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
`;

const Footer = styled.div`
  height: 40px;
  margin: 1rem;
  border-radius: 6px;
  background: #2a2a2a;
  animation: ${blink} 1.5s ease-in-out infinite;
  background: #2a2a2a;
  background-size: 1000px 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
`;

const PostSkeleton = () => {
  return (
    <SkeletonBox>
      <SkeletonHeader>
        <Avatar />
        <NameBlock />
      </SkeletonHeader>
      <Description />
      <ImagePlaceholder />
      <Footer />
    </SkeletonBox>
  );
};

export default PostSkeleton;
